import { Flex, Spinner, Text } from "@chakra-ui/react";
import { ErrorMessage } from "@iloq/shared-react/error-message";
import { useAxiosInstance } from "@iloq/shared-react/use-axios-instance.hook";
import { useQuery } from "@tanstack/react-query";
import { ReactElement } from "react";
import { FormattedMessage } from "react-intl";
import { PartnerStatsLinkButtons } from "./partner-stats-link-buttons";

interface SubscriptionsCount {
  count: number;
}

export function PartnerSubscriptions(): ReactElement {
  const axiosInstance = useAxiosInstance();
  const subscriptionsCountQuery = useQuery({
    queryKey: ["subscriptionsCount"],
    queryFn: async () => {
      const response = await axiosInstance.get<SubscriptionsCount>(`/api/v2/subscriptions/count`);
      if (response.status !== 200) {
        throw new Error(
          `Failed to get subscriptions count: ${response.status} - ${response.statusText}`,
        );
      }
      return response.data.count;
    },
  });

  if (subscriptionsCountQuery.isFetching) {
    return (
      <Flex flexDir="column" gap={{ base: "0", lg: "2" }} flex="50%">
        <Text fontWeight="bold" maxWidth={{ base: "140px", lg: "none" }} lineHeight="40px">
          <FormattedMessage id="partnerProgram.hero.subscriptions" />
        </Text>
        <Spinner />
      </Flex>
    );
  }

  if (subscriptionsCountQuery.isError) {
    return (
      <Flex flexDir="column" gap={{ base: "0", lg: "2" }} flex="50%">
        <Text fontWeight="bold" maxWidth={{ base: "140px", lg: "none" }} lineHeight="40px">
          <FormattedMessage id="partnerProgram.hero.subscriptions" />
        </Text>
        <ErrorMessage message={subscriptionsCountQuery.error.message} />
      </Flex>
    );
  }

  return (
    <PartnerStatsLinkButtons
      titleKey="partnerProgram.hero.subscriptions"
      count={subscriptionsCountQuery.data ?? "-"}
      titleLink="/subscriptions/list"
      createKey="partnerProgram.hero.newSubscription"
      createLink="/subscriptions/new"
    />
  );
}
